export enum SectionTitleAlignment {
  Left = 'Left',
  Centre = 'Centre',
}
